import React from "react";
import { NavLink, useLocation, matchPath } from "react-router-dom";
export const NavBarTodos = () => {
	const location = useLocation();
	const isActive = (path) => matchPath(location.pathname, { path: path });
	const activeNavStyle = (isActive) => {
		return isActive
			? "text-black font-bold topNav active-menu"
			: "text-black font-normal topNav inactive-menu";
	};

	return (
		<ul className={"grid grid-cols-3 gap-2 bg-white py-2"}>
			<li>
				<NavLink to="/dashboard/todo/setupdata" className={activeNavStyle}>
					<div
						className={`ss-icon text-2xl ${
							isActive("/dashboard/todo/setupdata") && "ss-glyphish-filled"
						}`}
					>
						&#x2699;
					</div>
					<span
						className={`name border-b-3 pb-1 ${
							isActive("/dashboard/todo/setupdata")
								? "border-black"
								: "border-transparent"
						}`}
					>
						Setup
					</span>
				</NavLink>
			</li>
			<li>
				<NavLink to="/dashboard/todo/regularreports" className={activeNavStyle}>
					<div
						className={`ss-icon text-2xl ${
							isActive("/dashboard/todo/regularreports") && "ss-glyphish-filled"
						}`}
					>
						&#xEC00;
					</div>
					<span
						className={`name border-b-3 pb-1 ${
							isActive("/dashboard/todo/regularreports")
								? "border-black"
								: "border-transparent"
						}`}
					>
						Reports
					</span>
				</NavLink>
			</li>
			<li>
				<NavLink to="/dashboard/todo/links" className={activeNavStyle}>
					<div
						className={`ss-icon ss-signpost text-2xl ${
							isActive("/dashboard/todo/links") && "ss-glyphish-filled"
						}`}
					></div>
					<span
						className={`name border-b-3 pb-1 ${
							isActive("/dashboard/todo/links")
								? "border-black"
								: "border-transparent"
						}`}
					>
						Resources
					</span>
				</NavLink>
			</li>
		</ul>
	);
};
